import { createReducer, INITIAL_STATE } from '@shared/redux';
import { isDataLoading, LOAD_STATE } from '@shared/axios';
import { setupAuthTokenInterceptor } from '@shared/NetworkService/interceptors/login';
import { getUserConfigApi, editUserConfigApi } from './user-config.api';
import { UserConfig } from './user-config.types';
import { DEFAULT_USER_CONFIG } from './user-config.constants';

export const GET_USER_CONFIG_REQUEST_CALLED = '@user-config/GET_USER_CONFIG_REQUEST_CALLED';
export const GET_USER_CONFIG_REQUEST_SUCCEEDED = '@user-config/GET_USER_CONFIG_REQUEST_SUCCEEDED';
export const GET_USER_CONFIG_REQUEST_FAILED = '@user-config/GET_USER_CONFIG_REQUEST_FAILED';
export const EDIT_USER_CONFIG_REQUEST_CALLED = '@user-config/EDIT_USER_CONFIG_REQUEST_CALLED';
export const EDIT_USER_CONFIG_REQUEST_SUCCEEDED = '@user-config/EDIT_USER_CONFIG_REQUEST_SUCCEEDED';
export const EDIT_USER_CONFIG_REQUEST_FAILED = '@user-config/EDIT_USER_CONFIG_REQUEST_FAILED';
export const CHANGE_CAMPAIGN_FILTER = '@user-config/CHANGE_CAMPAIGN_FILTER';
export const CHANGE_BIG_NUMBERS = '@user-config/CHANGE_BIG_NUMBERS';

export const getUserConfigData = state => state.userConfig?.data;
export const getUserConfigLoadState = state => state.userConfig.loadState;
export const getcampaignTableMetrics = state => state.userConfig?.data
    .DASHBOARD_FILTERS?.userLevel?.campaignTableMetrics;

export const hasConfigForSelectedObject = (state, configKey, entity, id) => {
    const { [configKey]: configs } = state.userConfig.data;
    if (!configs) return false;
    if (!configs[entity]) return false;
    if (!configs[entity][id]) return false;
    return true;
};

export const haveUserConfigAlreadyLoaded = (state) => {
    const userConfigLoadState = getUserConfigLoadState(state);
    return !isDataLoading(userConfigLoadState);
};

export const getConfigForSelectedObject = (
    state, configKey, entity, id,
) => {
    const { [configKey]: configs } = state.userConfig.data;

    return configs[entity][id];
};

const setupEnhancers = () => [setupAuthTokenInterceptor()];

const userConfigActionMeta = {
    axios: {
        clientConfig: {
            useDefaultEnhancers: false,
            enhancers: setupEnhancers(),
        },
    },
};

export const changeBigNumbers = bigNumbers => ({
    type: CHANGE_BIG_NUMBERS,
    payload: bigNumbers,
});

export const changeCampaignsFilter = metric => ({
    type: CHANGE_CAMPAIGN_FILTER,
    payload: metric,
});

export const getUserConfig = () => ({
    type: GET_USER_CONFIG_REQUEST_CALLED,
    actionTypes: {
        success: GET_USER_CONFIG_REQUEST_SUCCEEDED,
        fail: GET_USER_CONFIG_REQUEST_FAILED,
    },
    config: getUserConfigApi(),
    meta: userConfigActionMeta,
});

export const editUserConfig = newUserConfig => ({
    type: EDIT_USER_CONFIG_REQUEST_CALLED,
    actionTypes: {
        success: EDIT_USER_CONFIG_REQUEST_SUCCEEDED,
        fail: EDIT_USER_CONFIG_REQUEST_FAILED,
    },
    config: editUserConfigApi(newUserConfig),
    meta: userConfigActionMeta,
});

const initialState: UserConfig = {
    loadState: LOAD_STATE.LOADING,
    data: DEFAULT_USER_CONFIG,
    error: null,
};

export const userConfigReducer = createReducer({
    [INITIAL_STATE]: initialState,
    [GET_USER_CONFIG_REQUEST_CALLED]: state => ({
        ...state,
        loadState: LOAD_STATE.LOADING,
    }),
    [GET_USER_CONFIG_REQUEST_SUCCEEDED]: (state, action) => ({
        ...state,
        data: action.payload.data,
        loadState: LOAD_STATE.SUCCESS,
        error: null,
    }),
    [GET_USER_CONFIG_REQUEST_FAILED]: (state, action) => ({
        ...state,
        loadState: LOAD_STATE.FAIL,
        error: action.payload,
    }),
    [EDIT_USER_CONFIG_REQUEST_CALLED]: state => ({
        ...state,
        error: null,
    }),
    [EDIT_USER_CONFIG_REQUEST_SUCCEEDED]: (state, action) => ({
        ...state,
        data: {
            ...state.data,
            ...action.payload.data,
        },
        loadState: LOAD_STATE.SUCCESS,
        error: null,
    }),
    [EDIT_USER_CONFIG_REQUEST_FAILED]: (state, action) => ({
        ...state,
        loadState: LOAD_STATE.FAIL,
        error: action.payload,
    }),
});
